var map = {
	"./": [
		24,
		9
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Black.otf": [
		274,
		7,
		163
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Book.otf": [
		275,
		7,
		164
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Roman.otf": [
		276,
		7,
		165
	],
	"./assets/fonts/Perpetua/Perpetua Bold font.ttf": [
		277,
		7,
		166
	],
	"./assets/fonts/Perpetua/per_____.ttf": [
		278,
		7,
		167
	],
	"./assets/fonts/Perpetua/perb____.ttf": [
		279,
		7,
		168
	],
	"./assets/fonts/Perpetua/perpeta.ttf": [
		280,
		7,
		169
	],
	"./assets/fonts/Perpetua/unicode.perpetua.ttf": [
		281,
		7,
		170
	],
	"./assets/fonts/ProximaNova/ProximaNova-Regular.otf": [
		282,
		7,
		171
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Bold.otf": [
		283,
		7,
		172
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Light.otf": [
		284,
		7,
		173
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Thin.otf": [
		285,
		7,
		174
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Black.otf": [
		286,
		7,
		175
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Bold.otf": [
		287,
		7,
		176
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Extrabold.otf": [
		288,
		7,
		177
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Semibold.otf": [
		289,
		7,
		178
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Thin.otf": [
		290,
		7,
		179
	],
	"./assets/fonts/holidayfree.otf": [
		291,
		7,
		180
	],
	"./assets/fonts/satisfy-regular.ttf": [
		292,
		7,
		181
	],
	"./assets/images/Cooking.png": [
		293,
		7,
		204
	],
	"./assets/images/DACE_PROMO_final.mp4": [
		207,
		7,
		182
	],
	"./assets/images/RightArrow.svg": [
		208,
		7,
		183
	],
	"./assets/images/Right_arraw.png": [
		198,
		7,
		205
	],
	"./assets/images/UpArrow.png": [
		248,
		7,
		206
	],
	"./assets/images/VB DACE  _final.mp4": [
		249,
		7,
		184
	],
	"./assets/images/Vector.png": [
		294,
		7,
		207
	],
	"./assets/images/active_star.png": [
		295,
		7,
		208
	],
	"./assets/images/arrow1.png": [
		296,
		7,
		209
	],
	"./assets/images/arrow_gold.png": [
		209,
		7,
		210
	],
	"./assets/images/arrow_grey.png": [
		250,
		7,
		211
	],
	"./assets/images/banner/vb-dace-independence-day.jpg": [
		297,
		7,
		212
	],
	"./assets/images/cart_icon.jpg": [
		298,
		7,
		213
	],
	"./assets/images/chevron-down.png": [
		299,
		7,
		214
	],
	"./assets/images/chevron-up.png": [
		300,
		7,
		215
	],
	"./assets/images/circle_check_full_green.png": [
		239,
		7,
		216
	],
	"./assets/images/coolicon.png": [
		206,
		7,
		217
	],
	"./assets/images/delete.png": [
		251,
		7,
		218
	],
	"./assets/images/disabled_star.png": [
		301,
		7,
		219
	],
	"./assets/images/dot.png": [
		302,
		7,
		220
	],
	"./assets/images/down_button.png": [
		262,
		7,
		221
	],
	"./assets/images/eye.png": [
		241,
		7,
		222
	],
	"./assets/images/fb_logo.png": [
		303,
		7,
		223
	],
	"./assets/images/filter.png": [
		263,
		7,
		224
	],
	"./assets/images/flag.png": [
		304,
		7,
		225
	],
	"./assets/images/heart_icon.jpg": [
		305,
		7,
		226
	],
	"./assets/images/heart_icon.png": [
		306,
		7,
		227
	],
	"./assets/images/home/Arrow 2.jpg": [
		307,
		7,
		228
	],
	"./assets/images/home/LARGER MID SECTION BANNER.png": [
		203,
		7,
		229
	],
	"./assets/images/home/RED SMALL BANNER.png": [
		210,
		7,
		230
	],
	"./assets/images/home/SILVER SMALL BANNER.png": [
		211,
		7,
		231
	],
	"./assets/images/home/coolicon.jpg": [
		308,
		7,
		232
	],
	"./assets/images/home/diwali.jpg": [
		309,
		7,
		233
	],
	"./assets/images/home/pressBlock/company1.png": [
		212,
		7,
		234
	],
	"./assets/images/home/pressBlock/company2.png": [
		213,
		7,
		235
	],
	"./assets/images/home/pressBlock/company3.png": [
		214,
		7,
		236
	],
	"./assets/images/home/pressBlock/company4.png": [
		215,
		7,
		237
	],
	"./assets/images/home/pressBlock/company5.png": [
		216,
		7,
		238
	],
	"./assets/images/home/pressBlock/company6.png": [
		217,
		7,
		239
	],
	"./assets/images/home/serviceImage_1.png": [
		218,
		7,
		240
	],
	"./assets/images/home/serviceImage_2.png": [
		219,
		7,
		241
	],
	"./assets/images/home/serviceImage_3.png": [
		220,
		7,
		242
	],
	"./assets/images/home/serviceImage_4.png": [
		221,
		7,
		243
	],
	"./assets/images/home/serviceImage_5.png": [
		222,
		7,
		244
	],
	"./assets/images/home/slide/image1.png": [
		310,
		7,
		245
	],
	"./assets/images/home/slide/image2.png": [
		311,
		7,
		246
	],
	"./assets/images/home/slide/image3.png": [
		312,
		7,
		247
	],
	"./assets/images/home/slide/image4.png": [
		313,
		7,
		248
	],
	"./assets/images/home/slide/image5.png": [
		314,
		7,
		249
	],
	"./assets/images/home/slide/image6.png": [
		315,
		7,
		250
	],
	"./assets/images/home/slide/image7.png": [
		316,
		7,
		251
	],
	"./assets/images/home/slide/image8.png": [
		317,
		7,
		252
	],
	"./assets/images/home/slide/image9.png": [
		318,
		7,
		253
	],
	"./assets/images/home/slide/slide1.png": [
		252,
		7,
		254
	],
	"./assets/images/home/slide/slide2.png": [
		319,
		7,
		255
	],
	"./assets/images/home/slide/slide3.png": [
		320,
		7,
		256
	],
	"./assets/images/home/slide/slide4.png": [
		321,
		7,
		257
	],
	"./assets/images/home/slide/slide5.png": [
		322,
		7,
		258
	],
	"./assets/images/home/welcome_image.png": [
		323,
		7,
		259
	],
	"./assets/images/home/welcome_image_mobile.jpg": [
		324,
		7,
		260
	],
	"./assets/images/icons-new/customer-support.png": [
		224,
		7,
		261
	],
	"./assets/images/icons-new/quality-guaranteed.png": [
		225,
		7,
		262
	],
	"./assets/images/icons-new/quick-shipping.png": [
		226,
		7,
		263
	],
	"./assets/images/icons-new/secured-payments.png": [
		227,
		7,
		264
	],
	"./assets/images/icons/google-play-badge.png": [
		223,
		7,
		265
	],
	"./assets/images/imageLft_login.png": [
		325,
		7,
		266
	],
	"./assets/images/instagram_logo.png": [
		326,
		7,
		267
	],
	"./assets/images/leftArrow.png": [
		197,
		7,
		268
	],
	"./assets/images/leftArrow_a.png": [
		327,
		7,
		269
	],
	"./assets/images/lindedin_logo.png": [
		328,
		7,
		270
	],
	"./assets/images/loading.gif": [
		329,
		7,
		271
	],
	"./assets/images/logo.jpg": [
		330,
		7,
		272
	],
	"./assets/images/logo.png": [
		200,
		7,
		273
	],
	"./assets/images/logo_1x.png": [
		331,
		7,
		274
	],
	"./assets/images/logo_2x.png": [
		332,
		7,
		275
	],
	"./assets/images/logo_3x.png": [
		240,
		7,
		276
	],
	"./assets/images/logo_4x.png": [
		333,
		7,
		277
	],
	"./assets/images/logo_with_title.png": [
		334,
		7,
		278
	],
	"./assets/images/logo_with_title_old.png": [
		335,
		7,
		279
	],
	"./assets/images/minus.png": [
		242,
		7,
		280
	],
	"./assets/images/newsfeed_logo.png": [
		336,
		7,
		281
	],
	"./assets/images/next-btn-old.png": [
		337,
		7,
		282
	],
	"./assets/images/next-btn.png": [
		204,
		7,
		283
	],
	"./assets/images/offer/ALLPROBackpack.png": [
		338,
		7,
		284
	],
	"./assets/images/offer/SignatureBlackFront.png": [
		339,
		7,
		285
	],
	"./assets/images/offer/SignatureBlackSide.png": [
		340,
		7,
		286
	],
	"./assets/images/pagNext.png": [
		244,
		7,
		287
	],
	"./assets/images/pagPrevious.png": [
		245,
		7,
		288
	],
	"./assets/images/plus.png": [
		243,
		7,
		289
	],
	"./assets/images/pressNxtBtn.svg": [
		228,
		7,
		185
	],
	"./assets/images/pressPrevBtn.svg": [
		229,
		7,
		186
	],
	"./assets/images/prev-btn-old.png": [
		341,
		7,
		290
	],
	"./assets/images/prev-btn.png": [
		205,
		7,
		291
	],
	"./assets/images/product/Product_1.png": [
		342,
		7,
		292
	],
	"./assets/images/product/Product_2.png": [
		343,
		7,
		293
	],
	"./assets/images/product/Product_3.png": [
		344,
		7,
		294
	],
	"./assets/images/product/Product_4.png": [
		345,
		7,
		295
	],
	"./assets/images/product/category_banner.png": [
		264,
		7,
		296
	],
	"./assets/images/product/videoImg1.png": [
		265,
		7,
		297
	],
	"./assets/images/product/videoImg2.png": [
		266,
		7,
		298
	],
	"./assets/images/product/videoImg3.png": [
		267,
		7,
		299
	],
	"./assets/images/rightArrow.png": [
		199,
		7,
		300
	],
	"./assets/images/right_arrow_white.png": [
		230,
		7,
		301
	],
	"./assets/images/search_icon.png": [
		231,
		7,
		302
	],
	"./assets/images/sign_in_icon.jpg": [
		346,
		7,
		303
	],
	"./assets/images/square_minus.png": [
		253,
		7,
		304
	],
	"./assets/images/square_plus.png": [
		254,
		7,
		305
	],
	"./assets/images/tope.mp4": [
		232,
		7,
		187
	],
	"./assets/images/x-circle.png": [
		347,
		7,
		306
	],
	"./assets/images/x-shape.png": [
		348,
		7,
		307
	],
	"./assets/images/youtube_logo.png": [
		349,
		7,
		308
	],
	"./assets/scss/abstracts/_abstracts.scss": [
		350,
		7,
		203
	],
	"./assets/scss/abstracts/font.scss": [
		351,
		7,
		138
	],
	"./assets/scss/abstracts/functions.scss": [
		352,
		7,
		139
	],
	"./assets/scss/abstracts/mixins.scss": [
		353,
		7,
		140
	],
	"./assets/scss/abstracts/variables.scss": [
		354,
		7,
		141
	],
	"./assets/scss/common.scss": [
		355,
		7,
		142
	],
	"./assets/scss/default/default.scss": [
		356,
		7,
		143
	],
	"./assets/scss/default/utility.scss": [
		357,
		7,
		144
	],
	"./assets/scss/icons/fonts/icomoon.eot": [
		358,
		7,
		188
	],
	"./assets/scss/icons/fonts/icomoon.svg": [
		359,
		7,
		189
	],
	"./assets/scss/icons/fonts/icomoon.ttf": [
		360,
		7,
		190
	],
	"./assets/scss/icons/fonts/icomoon.woff": [
		361,
		7,
		191
	],
	"./assets/scss/icons/selection": [
		153,
		3,
		130
	],
	"./assets/scss/icons/selection.json": [
		153,
		3,
		130
	],
	"./assets/scss/icons/style.css": [
		362,
		7,
		135
	],
	"./assets/scss/index.scss": [
		121,
		7
	],
	"./assets/scss/layouts/AuthLayout.scss": [
		117,
		7
	],
	"./assets/scss/layouts/CategoryLayout.scss": [
		363,
		7,
		145
	],
	"./assets/scss/layouts/HomeLayout.scss": [
		364,
		7,
		146
	],
	"./assets/scss/layouts/ProductLayout.scss": [
		365,
		7,
		147
	],
	"./assets/scss/layouts/cartLayout.scss": [
		366,
		7,
		148
	],
	"./assets/scss/vendors/vendors-dir.scss": [
		367,
		7,
		149
	],
	"./assets/svg/Facebook-Fill.svg": [
		233,
		7,
		192
	],
	"./assets/svg/Facebook.svg": [
		234,
		7,
		193
	],
	"./assets/svg/Insta-Fill.svg": [
		235,
		7,
		194
	],
	"./assets/svg/Insta.svg": [
		236,
		7,
		195
	],
	"./assets/svg/Youtube-Fill.svg": [
		237,
		7,
		196
	],
	"./assets/svg/Youtube.svg": [
		238,
		7,
		197
	],
	"./assets/svg/account_circle.svg": [
		368,
		7,
		198
	],
	"./assets/svg/cancel.svg": [
		369,
		7,
		199
	],
	"./assets/svg/leftArrow.svg": [
		201,
		7,
		200
	],
	"./assets/svg/logo.svg": [
		370,
		7,
		201
	],
	"./assets/svg/rightArrow.svg": [
		202,
		7,
		202
	],
	"./component/Currency/page": [
		132,
		9,
		110
	],
	"./component/Currency/page.jsx": [
		132,
		9,
		110
	],
	"./component/StaticPageComponent/StaticPageComponent": [
		151,
		9,
		0,
		1,
		2,
		3,
		83
	],
	"./component/StaticPageComponent/StaticPageComponent.js": [
		151,
		9,
		0,
		1,
		2,
		3,
		83
	],
	"./component/StoreComponent": [
		59,
		9,
		6,
		57
	],
	"./component/StoreComponent/": [
		59,
		9,
		6,
		57
	],
	"./component/StoreComponent/Addresscard/AddressCard": [
		144,
		9,
		6,
		99
	],
	"./component/StoreComponent/Addresscard/AddressCard.js": [
		144,
		9,
		6,
		99
	],
	"./component/StoreComponent/Addresscard/styles.scss": [
		258,
		7,
		150
	],
	"./component/StoreComponent/index": [
		59,
		9,
		6,
		57
	],
	"./component/StoreComponent/index.js": [
		59,
		9,
		6,
		57
	],
	"./component/auth": [
		51,
		9,
		0,
		1,
		2,
		3,
		34
	],
	"./component/auth/": [
		51,
		9,
		0,
		1,
		2,
		3,
		34
	],
	"./component/auth/Activate": [
		46,
		9,
		0,
		1,
		2,
		3,
		42
	],
	"./component/auth/Activate/": [
		46,
		9,
		0,
		1,
		2,
		3,
		42
	],
	"./component/auth/Activate/index": [
		46,
		9,
		0,
		1,
		2,
		3,
		42
	],
	"./component/auth/Activate/index.js": [
		46,
		9,
		0,
		1,
		2,
		3,
		42
	],
	"./component/auth/ForgotPwd": [
		47,
		9,
		0,
		1,
		2,
		3,
		40
	],
	"./component/auth/ForgotPwd/": [
		47,
		9,
		0,
		1,
		2,
		3,
		40
	],
	"./component/auth/ForgotPwd/index": [
		47,
		9,
		0,
		1,
		2,
		3,
		40
	],
	"./component/auth/ForgotPwd/index.js": [
		47,
		9,
		0,
		1,
		2,
		3,
		40
	],
	"./component/auth/ForgotPwd/validate": [
		154,
		9,
		111
	],
	"./component/auth/ForgotPwd/validate.js": [
		154,
		9,
		111
	],
	"./component/auth/Login": [
		48,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/": [
		48,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/index": [
		48,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/index.js": [
		48,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/validate": [
		155,
		9,
		112
	],
	"./component/auth/Login/validate.js": [
		155,
		9,
		112
	],
	"./component/auth/ResetPwd": [
		49,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ResetPwd/": [
		49,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ResetPwd/index": [
		49,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ResetPwd/index.js": [
		49,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/Signup": [
		50,
		9,
		0,
		1,
		2,
		3,
		36
	],
	"./component/auth/Signup/": [
		50,
		9,
		0,
		1,
		2,
		3,
		36
	],
	"./component/auth/Signup/index": [
		50,
		9,
		0,
		1,
		2,
		3,
		36
	],
	"./component/auth/Signup/index.js": [
		50,
		9,
		0,
		1,
		2,
		3,
		36
	],
	"./component/auth/Signup/validate": [
		156,
		9,
		113
	],
	"./component/auth/Signup/validate.js": [
		156,
		9,
		113
	],
	"./component/auth/index": [
		51,
		9,
		0,
		1,
		2,
		3,
		34
	],
	"./component/auth/index.js": [
		51,
		9,
		0,
		1,
		2,
		3,
		34
	],
	"./component/blogDetail": [
		60,
		9,
		0,
		1,
		2,
		5,
		49
	],
	"./component/blogDetail/": [
		60,
		9,
		0,
		1,
		2,
		5,
		49
	],
	"./component/blogDetail/index": [
		60,
		9,
		0,
		1,
		2,
		5,
		49
	],
	"./component/blogDetail/index.js": [
		60,
		9,
		0,
		1,
		2,
		5,
		49
	],
	"./component/blogs": [
		61,
		9,
		0,
		1,
		2,
		5,
		44
	],
	"./component/blogs/": [
		61,
		9,
		0,
		1,
		2,
		5,
		44
	],
	"./component/blogs/blogCard": [
		145,
		9,
		5,
		105
	],
	"./component/blogs/blogCard.js": [
		145,
		9,
		5,
		105
	],
	"./component/blogs/index": [
		61,
		9,
		0,
		1,
		2,
		5,
		44
	],
	"./component/blogs/index.js": [
		61,
		9,
		0,
		1,
		2,
		5,
		44
	],
	"./component/cart": [
		62,
		9,
		0,
		1,
		2,
		43
	],
	"./component/cart/": [
		62,
		9,
		0,
		1,
		2,
		43
	],
	"./component/cart/index": [
		62,
		9,
		0,
		1,
		2,
		43
	],
	"./component/cart/index.js": [
		62,
		9,
		0,
		1,
		2,
		43
	],
	"./component/cart/offer_index": [
		157,
		9,
		0,
		1,
		2,
		96
	],
	"./component/cart/offer_index.js": [
		157,
		9,
		0,
		1,
		2,
		96
	],
	"./component/category": [
		63,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/category/": [
		63,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/category/index": [
		63,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/category/index.js": [
		63,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/category/old-index": [
		158,
		9,
		0,
		1,
		2,
		3,
		84
	],
	"./component/category/old-index.js": [
		158,
		9,
		0,
		1,
		2,
		3,
		84
	],
	"./component/category/tabs.category": [
		152,
		9,
		3,
		4,
		6,
		9,
		94
	],
	"./component/category/tabs.category.js": [
		152,
		9,
		3,
		4,
		6,
		9,
		94
	],
	"./component/common": [
		82,
		7,
		72
	],
	"./component/common/": [
		82,
		7,
		72
	],
	"./component/common/ChefNavTabs": [
		99,
		9,
		52
	],
	"./component/common/ChefNavTabs/": [
		99,
		9,
		52
	],
	"./component/common/ChefNavTabs/index": [
		99,
		9,
		52
	],
	"./component/common/ChefNavTabs/index.js": [
		99,
		9,
		52
	],
	"./component/common/ChefNavTabs/style.scss": [
		268,
		7,
		151
	],
	"./component/common/CommonPageLoader": [
		20,
		9
	],
	"./component/common/CommonPageLoader/": [
		20,
		9
	],
	"./component/common/CommonPageLoader/index": [
		20,
		9
	],
	"./component/common/CommonPageLoader/index.js": [
		20,
		9
	],
	"./component/common/CommonPageLoader/style.scss": [
		119,
		7
	],
	"./component/common/CommonTableLoader": [
		77,
		9,
		64
	],
	"./component/common/CommonTableLoader/": [
		77,
		9,
		64
	],
	"./component/common/CommonTableLoader/index": [
		77,
		9,
		64
	],
	"./component/common/CommonTableLoader/index.js": [
		77,
		9,
		64
	],
	"./component/common/CommonTableLoader/style.scss": [
		269,
		7,
		152
	],
	"./component/common/ErrorComponent": [
		57,
		9,
		69
	],
	"./component/common/ErrorComponent/": [
		57,
		9,
		69
	],
	"./component/common/ErrorComponent/index": [
		57,
		9,
		69
	],
	"./component/common/ErrorComponent/index.js": [
		57,
		9,
		69
	],
	"./component/common/FormErrorMessage": [
		45,
		9,
		70
	],
	"./component/common/FormErrorMessage/": [
		45,
		9,
		70
	],
	"./component/common/FormErrorMessage/index": [
		45,
		9,
		70
	],
	"./component/common/FormErrorMessage/index.js": [
		45,
		9,
		70
	],
	"./component/common/NormalButton": [
		78,
		9,
		71
	],
	"./component/common/NormalButton/": [
		78,
		9,
		71
	],
	"./component/common/NormalButton/index": [
		78,
		9,
		71
	],
	"./component/common/NormalButton/index.js": [
		78,
		9,
		71
	],
	"./component/common/NormalInput": [
		79,
		9,
		58
	],
	"./component/common/NormalInput/": [
		79,
		9,
		58
	],
	"./component/common/NormalInput/NormalInput.scss": [
		270,
		7,
		153
	],
	"./component/common/NormalInput/index": [
		79,
		9,
		58
	],
	"./component/common/NormalInput/index.js": [
		79,
		9,
		58
	],
	"./component/common/NormalSearch": [
		64,
		9,
		65
	],
	"./component/common/NormalSearch/": [
		64,
		9,
		65
	],
	"./component/common/NormalSearch/NormalSearch.scss": [
		259,
		7,
		154
	],
	"./component/common/NormalSearch/index": [
		64,
		9,
		65
	],
	"./component/common/NormalSearch/index.js": [
		64,
		9,
		65
	],
	"./component/common/NormalSelect": [
		80,
		9,
		8,
		59
	],
	"./component/common/NormalSelect/": [
		80,
		9,
		8,
		59
	],
	"./component/common/NormalSelect/index": [
		80,
		9,
		8,
		59
	],
	"./component/common/NormalSelect/index.js": [
		80,
		9,
		8,
		59
	],
	"./component/common/NormalSelect/select.scss": [
		271,
		7,
		155
	],
	"./component/common/Slider": [
		32,
		9,
		3,
		55
	],
	"./component/common/Slider/": [
		32,
		9,
		3,
		55
	],
	"./component/common/Slider/index": [
		32,
		9,
		3,
		55
	],
	"./component/common/Slider/index.js": [
		32,
		9,
		3,
		55
	],
	"./component/common/TableWrapper": [
		81,
		9,
		60
	],
	"./component/common/TableWrapper/": [
		81,
		9,
		60
	],
	"./component/common/TableWrapper/index": [
		81,
		9,
		60
	],
	"./component/common/TableWrapper/index.js": [
		81,
		9,
		60
	],
	"./component/common/TableWrapper/table.scss": [
		272,
		7,
		156
	],
	"./component/common/index": [
		82,
		7,
		72
	],
	"./component/common/index.js": [
		82,
		7,
		72
	],
	"./component/customerService": [
		75,
		9,
		9,
		61
	],
	"./component/customerService/": [
		75,
		9,
		9,
		61
	],
	"./component/customerService/index": [
		75,
		9,
		9,
		61
	],
	"./component/customerService/index.js": [
		75,
		9,
		9,
		61
	],
	"./component/home": [
		43,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./component/home/": [
		43,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./component/home/AdsofVBDACE": [
		65,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/": [
		65,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/index": [
		65,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/index.js": [
		65,
		9,
		4,
		50
	],
	"./component/home/AdsofVBDACE/style.module.css": [
		260,
		7,
		136
	],
	"./component/home/Banner": [
		34,
		9,
		73
	],
	"./component/home/Banner/": [
		34,
		9,
		73
	],
	"./component/home/Banner/index": [
		34,
		9,
		73
	],
	"./component/home/Banner/index.js": [
		34,
		9,
		73
	],
	"./component/home/BannerSwiper": [
		58,
		9,
		4,
		74
	],
	"./component/home/BannerSwiper/": [
		58,
		9,
		4,
		74
	],
	"./component/home/BannerSwiper/index": [
		58,
		9,
		4,
		74
	],
	"./component/home/BannerSwiper/index.js": [
		58,
		9,
		4,
		74
	],
	"./component/home/CollectionTabs": [
		66,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/home/CollectionTabs/": [
		66,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/home/CollectionTabs/index": [
		66,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/home/CollectionTabs/index.js": [
		66,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/home/DetailPage1": [
		35,
		9,
		75
	],
	"./component/home/DetailPage1/": [
		35,
		9,
		75
	],
	"./component/home/DetailPage1/index": [
		35,
		9,
		75
	],
	"./component/home/DetailPage1/index.js": [
		35,
		9,
		75
	],
	"./component/home/FooterBlock": [
		41,
		9,
		0,
		1,
		2,
		67,
		41
	],
	"./component/home/FooterBlock/": [
		41,
		9,
		0,
		1,
		2,
		67,
		41
	],
	"./component/home/FooterBlock/index": [
		41,
		9,
		0,
		1,
		2,
		67,
		41
	],
	"./component/home/FooterBlock/index.js": [
		41,
		9,
		0,
		1,
		2,
		67,
		41
	],
	"./component/home/ImgBlocks": [
		37,
		9,
		3,
		28,
		46
	],
	"./component/home/ImgBlocks/": [
		37,
		9,
		3,
		28,
		46
	],
	"./component/home/ImgBlocks/index": [
		37,
		9,
		3,
		28,
		46
	],
	"./component/home/ImgBlocks/index.js": [
		37,
		9,
		3,
		28,
		46
	],
	"./component/home/MultipleTabs": [
		38,
		9,
		0,
		1,
		2,
		4,
		29
	],
	"./component/home/MultipleTabs/": [
		38,
		9,
		0,
		1,
		2,
		4,
		29
	],
	"./component/home/MultipleTabs/index": [
		38,
		9,
		0,
		1,
		2,
		4,
		29
	],
	"./component/home/MultipleTabs/index.js": [
		38,
		9,
		0,
		1,
		2,
		4,
		29
	],
	"./component/home/PressBlock": [
		40,
		9,
		0,
		1,
		2,
		3,
		38
	],
	"./component/home/PressBlock/": [
		40,
		9,
		0,
		1,
		2,
		3,
		38
	],
	"./component/home/PressBlock/index": [
		40,
		9,
		0,
		1,
		2,
		3,
		38
	],
	"./component/home/PressBlock/index.js": [
		40,
		9,
		0,
		1,
		2,
		3,
		38
	],
	"./component/home/RecentBlogs": [
		67,
		9,
		0,
		1,
		2,
		5,
		45
	],
	"./component/home/RecentBlogs/": [
		67,
		9,
		0,
		1,
		2,
		5,
		45
	],
	"./component/home/RecentBlogs/index": [
		67,
		9,
		0,
		1,
		2,
		5,
		45
	],
	"./component/home/RecentBlogs/index.js": [
		67,
		9,
		0,
		1,
		2,
		5,
		45
	],
	"./component/home/ServiceBlock": [
		39,
		9,
		47
	],
	"./component/home/ServiceBlock/": [
		39,
		9,
		47
	],
	"./component/home/ServiceBlock/index": [
		39,
		9,
		47
	],
	"./component/home/ServiceBlock/index.js": [
		39,
		9,
		47
	],
	"./component/home/Slider": [
		36,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/home/Slider/": [
		36,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/home/Slider/index": [
		36,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/home/Slider/index.js": [
		36,
		9,
		0,
		1,
		2,
		3,
		35
	],
	"./component/home/TopNav": [
		42,
		9,
		0,
		1,
		2,
		8,
		33
	],
	"./component/home/TopNav/": [
		42,
		9,
		0,
		1,
		2,
		8,
		33
	],
	"./component/home/TopNav/index": [
		42,
		9,
		0,
		1,
		2,
		8,
		33
	],
	"./component/home/TopNav/index.js": [
		42,
		9,
		0,
		1,
		2,
		8,
		33
	],
	"./component/home/TopTabs": [
		33,
		9,
		0,
		1,
		2,
		8,
		53
	],
	"./component/home/TopTabs/": [
		33,
		9,
		0,
		1,
		2,
		8,
		53
	],
	"./component/home/TopTabs/index": [
		33,
		9,
		0,
		1,
		2,
		8,
		53
	],
	"./component/home/TopTabs/index.js": [
		33,
		9,
		0,
		1,
		2,
		8,
		53
	],
	"./component/home/VideoTestimonials": [
		76,
		9,
		4,
		51
	],
	"./component/home/VideoTestimonials/": [
		76,
		9,
		4,
		51
	],
	"./component/home/VideoTestimonials/index": [
		76,
		9,
		4,
		51
	],
	"./component/home/VideoTestimonials/index.js": [
		76,
		9,
		4,
		51
	],
	"./component/home/VideoTestimonials/style.module.css": [
		261,
		7,
		137
	],
	"./component/home/index": [
		43,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./component/home/index.js": [
		43,
		9,
		0,
		1,
		2,
		3,
		27
	],
	"./component/home/testimonials": [
		68,
		9,
		4,
		56
	],
	"./component/home/testimonials/": [
		68,
		9,
		4,
		56
	],
	"./component/home/testimonials/index": [
		68,
		9,
		4,
		56
	],
	"./component/home/testimonials/index.js": [
		68,
		9,
		4,
		56
	],
	"./component/myorder": [
		71,
		9,
		7,
		77
	],
	"./component/myorder/": [
		71,
		9,
		7,
		77
	],
	"./component/myorder/ReturnForm": [
		69,
		9,
		7,
		76
	],
	"./component/myorder/ReturnForm/": [
		69,
		9,
		7,
		76
	],
	"./component/myorder/ReturnForm/index": [
		69,
		9,
		7,
		76
	],
	"./component/myorder/ReturnForm/index.js": [
		69,
		9,
		7,
		76
	],
	"./component/myorder/ReturnTracking": [
		70,
		9,
		5,
		7,
		68
	],
	"./component/myorder/ReturnTracking/": [
		70,
		9,
		5,
		7,
		68
	],
	"./component/myorder/ReturnTracking/index": [
		70,
		9,
		5,
		7,
		68
	],
	"./component/myorder/ReturnTracking/index.js": [
		70,
		9,
		5,
		7,
		68
	],
	"./component/myorder/index": [
		71,
		9,
		7,
		77
	],
	"./component/myorder/index.js": [
		71,
		9,
		7,
		77
	],
	"./component/orders": [
		72,
		9,
		0,
		1,
		2,
		5,
		30
	],
	"./component/orders/": [
		72,
		9,
		0,
		1,
		2,
		5,
		30
	],
	"./component/orders/card": [
		148,
		9,
		5,
		95
	],
	"./component/orders/card.js": [
		148,
		9,
		5,
		95
	],
	"./component/orders/index": [
		72,
		9,
		0,
		1,
		2,
		5,
		30
	],
	"./component/orders/index.js": [
		72,
		9,
		0,
		1,
		2,
		5,
		30
	],
	"./component/product": [
		73,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./component/product/": [
		73,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./component/product/ProductSwiper": [
		53,
		9,
		4,
		6,
		48,
		66
	],
	"./component/product/ProductSwiper/": [
		53,
		9,
		4,
		6,
		48,
		66
	],
	"./component/product/ProductSwiper/index": [
		53,
		9,
		4,
		6,
		48,
		66
	],
	"./component/product/ProductSwiper/index.js": [
		53,
		9,
		4,
		6,
		48,
		66
	],
	"./component/product/ProductSwiper/styles.module.scss": [
		246,
		7,
		157
	],
	"./component/product/data/ManufacturingInfo": [
		141,
		9,
		114
	],
	"./component/product/data/ManufacturingInfo.js": [
		141,
		9,
		114
	],
	"./component/product/index": [
		73,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./component/product/index.js": [
		73,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./component/product/modal.product": [
		142,
		9,
		115
	],
	"./component/product/modal.product.js": [
		142,
		9,
		115
	],
	"./component/product/offer_index": [
		159,
		9,
		0,
		1,
		2,
		3,
		81
	],
	"./component/product/offer_index.js": [
		159,
		9,
		0,
		1,
		2,
		3,
		81
	],
	"./component/product/videoBlock.product": [
		160,
		9,
		3,
		6,
		97
	],
	"./component/product/videoBlock.product.js": [
		160,
		9,
		3,
		6,
		97
	],
	"./index": [
		24,
		9
	],
	"./index.js": [
		24,
		9
	],
	"./layout": [
		18,
		9
	],
	"./layout/": [
		18,
		9
	],
	"./layout/AuthLayout": [
		25,
		9
	],
	"./layout/AuthLayout.js": [
		25,
		9
	],
	"./layout/index": [
		18,
		9
	],
	"./layout/index.js": [
		18,
		9
	],
	"./pages": [
		96,
		9,
		78
	],
	"./pages/": [
		96,
		9,
		78
	],
	"./pages/Auth/activate": [
		161,
		9,
		0,
		1,
		2,
		3,
		89
	],
	"./pages/Auth/activate.js": [
		161,
		9,
		0,
		1,
		2,
		3,
		89
	],
	"./pages/Auth/forgotPwd": [
		162,
		9,
		0,
		1,
		2,
		3,
		90
	],
	"./pages/Auth/forgotPwd.js": [
		162,
		9,
		0,
		1,
		2,
		3,
		90
	],
	"./pages/Auth/login": [
		163,
		9,
		0,
		1,
		2,
		3,
		91
	],
	"./pages/Auth/login.js": [
		163,
		9,
		0,
		1,
		2,
		3,
		91
	],
	"./pages/Auth/resetPwd": [
		164,
		9,
		0,
		1,
		2,
		3,
		92
	],
	"./pages/Auth/resetPwd.js": [
		164,
		9,
		0,
		1,
		2,
		3,
		92
	],
	"./pages/Auth/signup": [
		165,
		9,
		0,
		1,
		2,
		3,
		93
	],
	"./pages/Auth/signup.js": [
		165,
		9,
		0,
		1,
		2,
		3,
		93
	],
	"./pages/BlogDetail": [
		83,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/BlogDetail/": [
		83,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/BlogDetail/index": [
		83,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/BlogDetail/index.js": [
		83,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/Blogs": [
		84,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/Blogs/": [
		84,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/Blogs/index": [
		84,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/Blogs/index.js": [
		84,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/Cart": [
		85,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Cart/": [
		85,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Cart/index": [
		85,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Cart/index.js": [
		85,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Category": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/Category/": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/Category/index": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/Category/index.js": [
		86,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/ContactUs": [
		87,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/ContactUs/": [
		87,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/ContactUs/index": [
		87,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/ContactUs/index.js": [
		87,
		9,
		0,
		1,
		2,
		3,
		26
	],
	"./pages/CustomerService": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/CustomerService/": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/CustomerService/index": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/CustomerService/index.js": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/Dummy/dummy": [
		166,
		9,
		0,
		1,
		2,
		3,
		85
	],
	"./pages/Dummy/dummy.js": [
		166,
		9,
		0,
		1,
		2,
		3,
		85
	],
	"./pages/Dummy/static": [
		167,
		9,
		0,
		1,
		2,
		3,
		82
	],
	"./pages/Dummy/static.js": [
		167,
		9,
		0,
		1,
		2,
		3,
		82
	],
	"./pages/Home": [
		89,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Home/": [
		89,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Home/index": [
		89,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Home/index.js": [
		89,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/MyOrder": [
		92,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/": [
		92,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/Return": [
		90,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./pages/MyOrder/Return/": [
		90,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./pages/MyOrder/Return/index": [
		90,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./pages/MyOrder/Return/index.js": [
		90,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./pages/MyOrder/ReturnStatus": [
		91,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/MyOrder/ReturnStatus/": [
		91,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/MyOrder/ReturnStatus/index": [
		91,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/MyOrder/ReturnStatus/index.js": [
		91,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/MyOrder/index": [
		92,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/MyOrder/index.js": [
		92,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/Orders": [
		93,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Orders/": [
		93,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Orders/index": [
		93,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Orders/index.js": [
		93,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/OurExperienceCenters": [
		94,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/OurExperienceCenters/": [
		94,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/OurExperienceCenters/index": [
		94,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/OurExperienceCenters/index.js": [
		94,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/OurExperienceCenters/style.module.scss": [
		273,
		7,
		158
	],
	"./pages/Product": [
		95,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/Product/": [
		95,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/Product/index": [
		95,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/Product/index.js": [
		95,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/about": [
		55,
		9,
		62
	],
	"./pages/about/": [
		55,
		9,
		62
	],
	"./pages/about/index": [
		55,
		9,
		62
	],
	"./pages/about/index.js": [
		55,
		9,
		62
	],
	"./pages/about/style.module.scss": [
		256,
		7,
		159
	],
	"./pages/index": [
		96,
		9,
		78
	],
	"./pages/index.js": [
		96,
		9,
		78
	],
	"./pages/kitchen-mate": [
		97,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/kitchen-mate/": [
		97,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/kitchen-mate/cocoChef": [
		168,
		9,
		0,
		1,
		2,
		3,
		86
	],
	"./pages/kitchen-mate/cocoChef.js": [
		168,
		9,
		0,
		1,
		2,
		3,
		86
	],
	"./pages/kitchen-mate/index": [
		97,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/kitchen-mate/index.js": [
		97,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/kitchen-mate/snackChef": [
		169,
		9,
		0,
		1,
		2,
		3,
		87
	],
	"./pages/kitchen-mate/snackChef.js": [
		169,
		9,
		0,
		1,
		2,
		3,
		87
	],
	"./pages/kitchen-mate/snackChefs": [
		170,
		9,
		0,
		1,
		2,
		3,
		88
	],
	"./pages/kitchen-mate/snackChefs.js": [
		170,
		9,
		0,
		1,
		2,
		3,
		88
	],
	"./pages/kitchen-mate/style.module.scss": [
		247,
		7,
		160
	],
	"./pages/shipping": [
		56,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/shipping/": [
		56,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/shipping/index": [
		56,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/shipping/index.js": [
		56,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./pages/shipping/style.module.scss": [
		257,
		7,
		161
	],
	"./pages/terms-use": [
		54,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/terms-use/": [
		54,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/terms-use/index": [
		54,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/terms-use/index.js": [
		54,
		9,
		0,
		1,
		2,
		3,
		25
	],
	"./pages/terms-use/style.module.scss": [
		255,
		7,
		162
	],
	"./redux/actions/actions": [
		12,
		9
	],
	"./redux/actions/actions.js": [
		12,
		9
	],
	"./redux/actions/productAction": [
		130,
		9,
		116
	],
	"./redux/actions/productAction.js": [
		130,
		9,
		116
	],
	"./redux/actions/userAction": [
		171,
		9,
		0,
		1,
		2,
		100
	],
	"./redux/actions/userAction.js": [
		171,
		9,
		0,
		1,
		2,
		100
	],
	"./redux/reducers": [
		19,
		9
	],
	"./redux/reducers/": [
		19,
		9
	],
	"./redux/reducers/index": [
		19,
		9
	],
	"./redux/reducers/index.js": [
		19,
		9
	],
	"./redux/reducers/taskReducer": [
		28,
		9
	],
	"./redux/reducers/taskReducer.js": [
		28,
		9
	],
	"./redux/store/store": [
		14,
		9
	],
	"./redux/store/store.js": [
		14,
		9
	],
	"./redux_old/actions/actionTypes": [
		137,
		9,
		117
	],
	"./redux_old/actions/actionTypes.js": [
		137,
		9,
		117
	],
	"./redux_old/actions/commonAction": [
		172,
		9,
		106
	],
	"./redux_old/actions/commonAction.js": [
		172,
		9,
		106
	],
	"./redux_old/actions/productAction": [
		173,
		9,
		107
	],
	"./redux_old/actions/productAction.js": [
		173,
		9,
		107
	],
	"./redux_old/reducer": [
		74,
		9,
		63
	],
	"./redux_old/reducer/": [
		74,
		9,
		63
	],
	"./redux_old/reducer/commonStore": [
		149,
		9,
		108
	],
	"./redux_old/reducer/commonStore.js": [
		149,
		9,
		108
	],
	"./redux_old/reducer/index": [
		74,
		9,
		63
	],
	"./redux_old/reducer/index.js": [
		74,
		9,
		63
	],
	"./redux_old/reducer/productStore": [
		150,
		9,
		109
	],
	"./redux_old/reducer/productStore.js": [
		150,
		9,
		109
	],
	"./redux_old/store": [
		98,
		9,
		54
	],
	"./redux_old/store/": [
		98,
		9,
		54
	],
	"./redux_old/store/index": [
		98,
		9,
		54
	],
	"./redux_old/store/index.js": [
		98,
		9,
		54
	],
	"./routes": [
		17,
		9
	],
	"./routes/": [
		17,
		9
	],
	"./routes/index": [
		17,
		9
	],
	"./routes/index.js": [
		17,
		9
	],
	"./routes/routes": [
		27,
		9
	],
	"./routes/routes.js": [
		27,
		9
	],
	"./service/apis": [
		52,
		9,
		79
	],
	"./service/apis/": [
		52,
		9,
		79
	],
	"./service/apis/blogs.apis": [
		134,
		9,
		0,
		1,
		2,
		101
	],
	"./service/apis/blogs.apis.js": [
		134,
		9,
		0,
		1,
		2,
		101
	],
	"./service/apis/customer.apis": [
		129,
		9,
		0,
		1,
		2,
		98
	],
	"./service/apis/customer.apis.js": [
		129,
		9,
		0,
		1,
		2,
		98
	],
	"./service/apis/index": [
		52,
		9,
		79
	],
	"./service/apis/index.js": [
		52,
		9,
		79
	],
	"./service/apis/products.apis": [
		128,
		9,
		0,
		1,
		2,
		102
	],
	"./service/apis/products.apis.js": [
		128,
		9,
		0,
		1,
		2,
		102
	],
	"./service/graphql": [
		31,
		9,
		0,
		1,
		80
	],
	"./service/graphql/": [
		31,
		9,
		0,
		1,
		80
	],
	"./service/graphql/apiQuery": [
		127,
		9,
		0,
		2,
		118
	],
	"./service/graphql/apiQuery.js": [
		127,
		9,
		0,
		2,
		118
	],
	"./service/graphql/index": [
		31,
		9,
		0,
		1,
		80
	],
	"./service/graphql/index.js": [
		31,
		9,
		0,
		1,
		80
	],
	"./serviceWorker": [
		29,
		9
	],
	"./serviceWorker.js": [
		29,
		9
	],
	"./utils/CodeSplitter": [
		15,
		9
	],
	"./utils/CodeSplitter.js": [
		15,
		9
	],
	"./utils/Constants": [
		174,
		9,
		119
	],
	"./utils/Constants.js": [
		174,
		9,
		119
	],
	"./utils/CouponDisplay": [
		175,
		9,
		103
	],
	"./utils/CouponDisplay.js": [
		175,
		9,
		103
	],
	"./utils/Currency": [
		133,
		9,
		120
	],
	"./utils/Currency.js": [
		133,
		9,
		120
	],
	"./utils/FormValidation": [
		136,
		9,
		121
	],
	"./utils/FormValidation.js": [
		136,
		9,
		121
	],
	"./utils/MetaData": [
		16,
		9
	],
	"./utils/MetaData.js": [
		16,
		9
	],
	"./utils/QuteSvg": [
		140,
		9,
		122
	],
	"./utils/QuteSvg.js": [
		140,
		9,
		122
	],
	"./utils/TestimonialsData": [
		139,
		9,
		123
	],
	"./utils/TestimonialsData.js": [
		139,
		9,
		123
	],
	"./utils/VideoTestimonialData": [
		146,
		9,
		124
	],
	"./utils/VideoTestimonialData.js": [
		146,
		9,
		124
	],
	"./utils/dateCustomFormat": [
		147,
		9,
		5,
		125
	],
	"./utils/dateCustomFormat.js": [
		147,
		9,
		5,
		125
	],
	"./utils/helperFunctions": [
		138,
		9,
		126
	],
	"./utils/helperFunctions.js": [
		138,
		9,
		126
	],
	"./utils/mock": [
		143,
		9,
		127
	],
	"./utils/mock.js": [
		143,
		9,
		127
	],
	"./utils/temp": [
		135,
		3,
		131
	],
	"./utils/temp.json": [
		135,
		3,
		131
	],
	"./utils/toast": [
		131,
		9,
		128
	],
	"./utils/toast.js": [
		131,
		9,
		128
	],
	"./utils/validation": [
		176,
		9,
		104,
		129
	],
	"./utils/validation.js": [
		176,
		9,
		104,
		129
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 183;
module.exports = webpackAsyncContext;